module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar3-event-fill-866da57c.svg";